import React, { useEffect, useState } from "react";
import { PieChart } from 'react-minimal-pie-chart';
import { translate } from '../Services/translation';

export default function MCSSearchWords(props) {

    const {
        searchWords,
        saveButtonValue,
        removeButtonValue,
        id,
        otherSearchWords,
        trafic
    } = props;

    let firstSearchWord = searchWords != null ? searchWords.length > 0 && searchWords[0].title != null ? searchWords[0].title : "" : "";

    const [enabledInput, setEnabledInput] = useState(false);
    const [textValue, setTextValue] = useState("");
    const [warning, setWarning] = useState("");
    const [activeWord, setActiveWord] = useState(firstSearchWord);
    const [activeTab, setActiveTab] = useState(1);

    const toggleInput = () => {
        setEnabledInput(!enabledInput);
    }

    const setButtonValue = (value) => {
        setWarning("");
        setTextValue(value);
    }

    //remove tracked keywords from other keywords
    let keywordStringsX = searchWords != null ? searchWords.map(x => {return x.title}) : "";
    let alternativeSearchWords = otherSearchWords != null ? otherSearchWords.filter(y => !keywordStringsX.includes(y.title)) : null;

    const saveCurrentButtonValue = (textValue) => {
        let value = textValue.trim();
        if (searchWords.filter(x => x.title.toLowerCase() == value.toLowerCase()).length > 0) {
            setWarning("The frase already exists");
        }
        else if (value.replace(" ", "").length > 0) {
            saveButtonValue(value, id)
            setTextValue("");
        }
        else {
            setWarning("You have to have a value")
        }
    }

    const changeActiveWord = (value) => {
        setActiveWord(searchWords.filter(x => x.title == value)[0].title);
    }

    const removeCurrentButtonValue = (value) => {
        if (activeWord == value) {
            setActiveWord(searchWords.length > 0 && searchWords[0].title != null ? searchWords[0].title : "");
        }
        removeButtonValue(value, id);
    }

    const getColor = (value, isVolumeContainer = false) => {
        if (!isVolumeContainer) {
            if (value > 0 && value < 11) {
                return '#72b77a';
            }
            else if (value > 10 && value < 31) {
                return '#ffcf28';
            }
            else {
                return '#d06262';
            }
        }
        else {
            if (value > 0 && value < 10) {
                return '#d06262';
            }
            else if (value > 10 && value < 20) {
                return '#ffcf28';
            }
            else {
                return '#72b77a';
            }
        }
    }


    const hasPositionData = searchWords && searchWords.length > 0 && searchWords.filter(x => x.title == activeWord).length > 0 && searchWords.filter(x => x.title == activeWord)[0].position != -1;
    const hasVolumeData = searchWords && searchWords.length > 0 && searchWords.filter(x => x.title == activeWord).length > 0 && searchWords.filter(x => x.title == activeWord)[0].volume != -1;
    const hasTrafficData = trafic && trafic != -1;

    return (
        <>
            <div className="mcs__search-word">
                <div className="mcs__tab-container">
                    <div className={activeTab == 1 ? "col-6 mcs__tab no-select mcs__tab--active" : "col-6 mcs__tab no-select"} onClick={() => setActiveTab(1)}>{translate("mcs.mysearchword")}</div><div className={activeTab == 2 ? "col-6 mcs__tab no-select mcs__tab--active" : "col-6 mcs__tab no-select"} onClick={() => setActiveTab(2)}>{translate("mcs.otherkeywords")}</div>
                </div>
                {activeTab == 1 &&
                    <div className="mcs__statistics-tab">
                        <div className="mcs__add-search-item">
                            <div className="mcs__add-search-item-btn no-select col-6" onClick={() => toggleInput()}>{translate("mcs.addkeyword")}<i className={enabledInput ? "fal fa-arrow-circle-right enabled" : "fal fa-arrow-circle-right"}></i></div>
                            <div className="mcs__add-btn-input-container">
                                <input tabIndex="-1" className={enabledInput ? "visible-input" : ""} value={textValue} type="text" name="buttontext" onChange={(event) => setButtonValue(event.target.value)} />
                                <i className={enabledInput ? "fal fa-plus visible-icon" : ""} onClick={() => saveCurrentButtonValue(textValue)}></i>
                                {warning != "" && <span>{warning}</span>}
                            </div>
                        </div>
                        <div className="mcs__search-item">
                            {searchWords != null && searchWords.length > 0 && searchWords.map((item) => (
                                <div className="btn-container" key={"btn" + item.title}>
                                    <button tabIndex="-1" className={item.title == activeWord ? "active" : ""} onClick={() => changeActiveWord(item.title)}>{item.title}</button>
                                    <i className="fas fa-times" onClick={() => removeCurrentButtonValue(item.title, id)}></i>
                                </div>
                            ))}
                        </div>
                        <div className="mcs__search-statistics">
                            {activeWord != '' && searchWords != null && searchWords.length > 0 && searchWords.filter(x => x.title == activeWord).length > 0 ?
                                <>
                                    <div className="col-12 top-row">
                                        <div className="col-4">Position</div>
                                        {hasVolumeData ? <div className="col-4">Volume {searchWords.filter(x => x.title == activeWord)[0].volume != -1 && searchWords.filter(x => x.title == activeWord)[0].totalVolume != -1 && "(" + searchWords.filter(x => x.title == activeWord)[0].volume + "/" + searchWords.filter(x => x.title == activeWord)[0].totalVolume + ")"}</div> : null}
                                        {hasTrafficData ? <div className="col-4">Traffic to url</div> : null}
                                    </div>
                                    <div className="col-12 bottom-row">
                                    {searchWords.filter(x => x.title == activeWord)[0].position != -1 ?
                                        <div className="mcs__position-container col-4">                                        
                                                <PieChart
                                                    data={[{ value: 100 - searchWords.filter(x => x.title == activeWord)[0].position, color: getColor(searchWords.filter(x => x.title == activeWord)[0].position) }]}
                                                    animate={true}
                                                    totalValue={100}
                                                    lineWidth={20}
                                                    viewBoxSize={[150, 100]}
                                                    label={({ dataEntry }) => searchWords.filter(x => x.title == activeWord)[0].position}
                                                    labelStyle={{
                                                        fontSize: '25px',
                                                        fill: getColor(searchWords.filter(x => x.title == activeWord)[0].position),
                                                    }}
                                                    labelPosition={0}
                                                />                                          
                                        </div>
                                        : "No statistics available"
                                        }
                                        {searchWords.filter(x => x.title == activeWord)[0].volume != -1 ?
                                        <div className="mcs__volume-container col-4">
                                                <PieChart
                                                    data={[{ value: (searchWords.filter(x => x.title == activeWord)[0].volume / searchWords.filter(x => x.title == activeWord)[0].totalVolume) * 100, color: getColor((searchWords.filter(x => x.title == activeWord)[0].volume / searchWords.filter(x => x.title == activeWord)[0].totalVolume) * 100, true) }]}
                                                    animate={true}
                                                    totalValue={100}
                                                    lineWidth={20}
                                                    viewBoxSize={[150, 100]}
                                                    label={({ dataEntry }) => Math.round((searchWords.filter(x => x.title == activeWord)[0].volume / searchWords.filter(x => x.title == activeWord)[0].totalVolume) * 100) + "%"}
                                                    labelStyle={{
                                                        fontSize: '25px',
                                                        fill: getColor((searchWords.filter(x => x.title == activeWord)[0].volume / searchWords.filter(x => x.title == activeWord)[0].totalVolume) * 100, true),
                                                    }}
                                                    labelPosition={0}
                                                />
                                        </div> : null
                                        }
                                        {trafic && trafic != -1 ?
                                        <div className="mcs__total-volume-container col-4">
                                                <PieChart
                                                    data={[{ value: trafic, color: '#87b3ba' }]}
                                                    animate={true}
                                                    totalValue={100}
                                                    lineWidth={20}
                                                    viewBoxSize={[150, 100]}
                                                    label={({ dataEntry }) => trafic + "%"}
                                                    labelStyle={{
                                                        fontSize: '25px',
                                                        fill: '#87b3ba',
                                                    }}
                                                    labelPosition={0}
                                                />                                            
                                        </div> : null
                                        }
                                    </div>
                                </>
                                :
                                "No statistics available"
                            }
                        </div>
                    </div>
                }
                {activeTab == 2 &&
                    <div className="mcs__secondary-tab">
                        <div className="col-12 mcs__list-heading-row"><div className="col-6">{translate("mcs.keyword")}</div><div className="col-6">{translate("mcs.position")}</div></div>
                        <div className="mcs__list-container">
                            {alternativeSearchWords != null && alternativeSearchWords.length > 0 ? alternativeSearchWords.map((item) => (
                                <div key={"sw-" + item.title} className="mcs__list-row">
                                    <div className="col-6">
                                        {item.title}
                                    </div>
                                    <div className="col-6" style={{ color: getColor(item.position) }}>
                                        {item.position}
                                    </div>
                                </div>
                            ))
                                :
                                <div className="mcs__list-row">
                                    {translate("notrackedkeywords")}
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

MCSSearchWords.defaultProps = {
    searchWords: []
}

